module.exports = __webpack_public_path__ + "static/media/call.b38a46a4.svg";